import { render, staticRenderFns } from "./Thumbnails.vue?vue&type=template&id=2d24d0c5&scoped=true"
import script from "./Thumbnails.vue?vue&type=script&lang=js"
export * from "./Thumbnails.vue?vue&type=script&lang=js"
import style0 from "./Thumbnails.vue?vue&type=style&index=0&id=2d24d0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24d0c5",
  null
  
)

export default component.exports